import { createFileRoute } from '@tanstack/react-router';

import Page from '@/screens/settings/security/page';

export const Route = createFileRoute('/_app/settings/security/')({
  component: Page,
});
